import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './app.types'

@Injectable({ providedIn: 'root' })
export class app_validate_serial_numbersService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { licenseplate: string, serialnumbers: { lookupcode: string }[], warehouseId: number }): Promise<{ response?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.licenseplate)) {
      missingRequiredInParams.push('\'licenseplate\'');
    }
    if (isNil(inParams.serialnumbers)) {
      missingRequiredInParams.push('\'serialnumbers\'');
    }
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/app/functions/validate_serial_numbers`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

